import { logsSearchSchema } from "@commerce/logs/meta";
import { z } from "zod";

export const channelsSearchSchema = z.object({
	/** The connect dialog is open. */
	connect: z.boolean().optional(),
});

/** One number's tabs (spec 5.1), in order. */
export const NUMBER_TABS = [
	"overview",
	"profile",
	"calling",
	"catalog",
	"templates",
	"activity",
	"settings",
] as const;
export type NumberTab = (typeof NUMBER_TABS)[number];

export const NUMBER_TAB_LABEL: Record<NumberTab, string> = {
	overview: "Overview",
	profile: "Profile",
	calling: "Calling",
	catalog: "Catalog and checkout",
	templates: "Templates",
	activity: "Activity",
	settings: "Settings",
};

/** The tab, the test sheet, and the Activity tab's log filters, all in the URL. */
export const numberSearchSchema = logsSearchSchema
	.omit({ number: true })
	.extend({
		tab: z.enum(NUMBER_TABS).optional(),
		/** The "Send a test" sheet is open. */
		test: z.boolean().optional(),
	});
export type NumberSearch = z.infer<typeof numberSearchSchema>;

export const TEMPLATE_STATUSES = [
	"APPROVED",
	"PENDING",
	"REJECTED",
	"PAUSED",
	"DISABLED",
] as const;

export const templatesSearchSchema = z.object({
	status: z.enum(TEMPLATE_STATUSES).optional(),
	/** A Messaging account, when the retailer has several. */
	account: z.string().optional(),
	/** The editor sheet: "new", or a template id to look at. */
	template: z.string().optional(),
});
export type TemplatesSearch = z.infer<typeof templatesSearchSchema>;
